"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.businessSizeConfig = void 0;
const Currency_1 = require("../enm/Currency");
const Country_1 = require("../enm/Country");
const BusinessSize_1 = require("../enm/BusinessSize");
// Tier thresholds in SEK
const TIERS = {
    [BusinessSize_1.BusinessSize.SMALL]: { to: BusinessSize_1.BusinessSize.MEDIUM },
    [BusinessSize_1.BusinessSize.MEDIUM]: { from: BusinessSize_1.BusinessSize.MEDIUM, to: BusinessSize_1.BusinessSize.LARGE },
    [BusinessSize_1.BusinessSize.LARGE]: { from: BusinessSize_1.BusinessSize.LARGE },
};
const CONVERSION_RATE = {
    [Currency_1.Currency.AUD]: 0.14,
    [Currency_1.Currency.CAD]: 0.13,
    [Currency_1.Currency.CZK]: 2.15,
    [Currency_1.Currency.DKK]: 0.67,
    [Currency_1.Currency.EUR]: 0.089,
    [Currency_1.Currency.NZD]: 0.15,
    [Currency_1.Currency.NOK]: 0.95,
    [Currency_1.Currency.PLN]: 0.42,
    [Currency_1.Currency.SEK]: 1,
    [Currency_1.Currency.CHF]: 0.089,
    [Currency_1.Currency.GBP]: 0.078,
    [Currency_1.Currency.USD]: 0.096,
};
const COUNTRY_CURRENCY = {
    [Country_1.Country.AU]: Currency_1.Currency.AUD,
    [Country_1.Country.AT]: Currency_1.Currency.EUR,
    [Country_1.Country.BE]: Currency_1.Currency.EUR,
    [Country_1.Country.CA]: Currency_1.Currency.CAD,
    [Country_1.Country.CZ]: Currency_1.Currency.CZK,
    [Country_1.Country.DK]: Currency_1.Currency.DKK,
    [Country_1.Country.FI]: Currency_1.Currency.EUR,
    [Country_1.Country.FR]: Currency_1.Currency.EUR,
    [Country_1.Country.DE]: Currency_1.Currency.EUR,
    [Country_1.Country.GR]: Currency_1.Currency.EUR,
    [Country_1.Country.IE]: Currency_1.Currency.EUR,
    [Country_1.Country.IT]: Currency_1.Currency.EUR,
    [Country_1.Country.NL]: Currency_1.Currency.EUR,
    [Country_1.Country.NZ]: Currency_1.Currency.NZD,
    [Country_1.Country.NO]: Currency_1.Currency.NOK,
    [Country_1.Country.PL]: Currency_1.Currency.PLN,
    [Country_1.Country.PT]: Currency_1.Currency.EUR,
    [Country_1.Country.ES]: Currency_1.Currency.EUR,
    [Country_1.Country.SE]: Currency_1.Currency.SEK,
    [Country_1.Country.CH]: Currency_1.Currency.CHF,
    [Country_1.Country.GB]: Currency_1.Currency.GBP,
    [Country_1.Country.US]: Currency_1.Currency.USD,
};
const businessSizeConfig = (payload) => {
    const country = payload?.business_information?.registration_country || Country_1.Country.SE;
    const currency = COUNTRY_CURRENCY[country] || Currency_1.Currency.SEK;
    const rate = CONVERSION_RATE[currency] || 1;
    return { currency, rate, tiers: TIERS };
};
exports.businessSizeConfig = businessSizeConfig;
